import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const LeadershipDev = () => {
  return (
    <div className="w-full bg-white">
      <PageHeader 
        title="Leadership Development" 
        description="Led by Linda Boes. Building capable leaders who drive safety, performance, and culture." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col-reverse lg:flex-row gap-16">
          <div className="lg:w-1/3">
            <div className="bg-brand-light p-6 rounded-2xl border border-slate-200 sticky top-28">
              <h3 className="font-bold text-brand-navy text-xl mb-4">Program Focus Areas</h3>
              <ul className="space-y-3 text-sm font-medium text-slate-700">
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Front-line supervisor development</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Leadership academies</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Executive coaching & Mentorship</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Emotional intelligence</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Communication & conflict management</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Performance management</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Strategic alignment (Balanced Scorecards)</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Team effectiveness</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Succession & career development</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Employee evaluation systems</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiChevronRight} className="text-brand-green" /> Change leadership</li>
              </ul>
            </div>
          </div>

          <div className="lg:w-2/3 prose prose-slate prose-lg">
            <h2 className="text-brand-navy font-bold">Developing the Future Workforce</h2>
            <p>
              The most robust emergency plans and safety protocols will fail if the leaders overseeing them lack the skills to communicate, influence, and manage their people effectively.
            </p>
            <p>
              Led by CEO Linda Boes, our Leadership Development programs utilize industrial psychology and proven organizational management strategies to build capable, emotionally intelligent leaders at every level of your organization.
            </p>

            <div className="bg-brand-navy text-white p-8 rounded-xl my-8 not-prose">
              <h3 className="text-brand-green font-bold text-xl mb-3">Why Emotional Intelligence (EQ)?</h3>
              <p className="text-slate-300 font-medium text-sm leading-relaxed m-0">
                Technical competence alone does not make a successful leader or safety officer. Emotional intelligence dictates how leaders manage stress during a crisis, navigate conflicts during incident investigations, and influence compliance behavior on the shop floor. We utilize tools like the EQ-i 2.0 to establish baselines and build critical interpersonal skills.
              </p>
            </div>

            <h3 className="text-brand-navy font-bold">View Leadership Courses</h3>
            <p>
              We offer a wide array of standardized and custom leadership courses ranging from "Managing with Emotional Intelligence" to complex conflict negotiation. 
            </p>
            <Link to="/training/catalog" className="not-prose inline-flex items-center gap-2 text-brand-navy font-bold hover:text-brand-green transition-colors mt-4">
              Browse Leadership Catalog <SafeIcon icon={FiIcons.FiArrowRight} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LeadershipDev;